(() => {
  function init(scope) {
    scope.querySelectorAll('.ar-about').forEach(root => {
      if (root.dataset.journeyReady) return;
      root.dataset.journeyReady = 'true';
      const track = root.querySelector('.ar-journey__track');
      const prev = root.querySelector('[data-journey-prev]');
      const next = root.querySelector('[data-journey-next]');
      if (!track || !prev || !next) return;
      const update = () => {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      const move = direction => {
        const item = track.querySelector('.ar-journey__item');
        const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap) : track.clientWidth;
        track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(track);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) observer.disconnect();
        }, {once:true});
      }
      update();
    });
  }
  init(document);
  if (!window.awaakiiAboutV19Bound) {
    window.awaakiiAboutV19Bound = true;
    document.addEventListener('shopify:section:load', event => init(event.target));
  }
})();
